import React, { useState } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import Sidebar from './components/Sidebar';
import TranscribeTab from './components/TranscribeTab';
import DashboardTab from './components/DashboardTab';
import DeepanalysisTab from './components/DeepanalysisTab';
import PromptManagementTab from './components/PromptManagementTab';
import SubscriptionTab from './components/SubscriptionTab';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import '@aws-amplify/ui-react/styles.css';
import './index.css';
import logo from './assets/logo-rcs.png';
import ClientSetupTab from './components/ClientSetupTab';
import ClientScorecardTab from './components/ClientScorecardTab';
import ConfigurationTab from './components/ConfigurationTab';
import ContactUsTab from './components/ContactUsTab';
import HelpTab from './components/HelpTab';
import CoPilotTab from './components/CoPilotTab';
import ReportsTab from './components/ReportsTab';
import LandingPage from './components/LandingPage';


Amplify.configure(awsExports);

const App = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [sidebarVisible, setSidebarVisible] = useState(true);

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
    setSidebarVisible(false); // Auto-hide sidebar after selection
  };


  const components = {
    SignIn: {
      Header() {
        return (
          <div className="text-center mb-6">
            <h1 className="text-3xl font-bold text-blue-800">
              Yaqeen GenAI QA Monitor™
            </h1>
          </div>
        );
      },
      Footer() {
        return (
          <div className="text-center text-xs text-gray-400 mt-6">
            © {new Date().getFullYear()} Yaqeen Technologies. All rights reserved.
          </div>
        );
      }
    }
  };

  return (
    <Authenticator components={components} hideSignUp>
      {({ signOut, user }) =>
        user ? (
          <div className="flex min-h-screen bg-gray-100">
            {/* Sidebar */}
            <Sidebar
              selectedTab={activeTab}
              onSelectTab={handleTabSelect}
              isVisible={sidebarVisible}
            />

            {/* Hamburger Toggle */}
            {!sidebarVisible && (
              <button
                className="fixed top-4 left-4 z-50 bg-gray-800 text-white p-2 rounded shadow"
                onClick={() => setSidebarVisible(true)}
              >
                ☰
              </button>
            )}

            {/* Main Content */}
            <div
              className={`transition-all duration-300 flex-1 p-6 ${
                sidebarVisible ? 'ml-64' : 'ml-0'
              }`}
            >
              {/* Header */}
              <div className="flex justify-center items-center mb-6 space-x-4">
                <img src={logo} alt="Logo" className="w-20 h-20 object-contain" />
                <h1 className="text-4xl font-bold text-blue-800">
                  Reliant Capital Solutions
                </h1>
              </div>

              {/* Sign Out */}
              <div className="flex justify-end -mt-6 mb-2 pr-4">
                <div className="flex items-center space-x-4">
                  <span>{user.username}</span>
                  <button
                    onClick={signOut}
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                  >
                    Sign Out
                  </button>
                </div>
              </div>

              {/* Tabs */}
              {activeTab === 'prompts' && <PromptManagementTab />}
              {activeTab === 'transcribe' && <TranscribeTab />}
              {activeTab === 'dashboard' && <DashboardTab />}
              {activeTab === 'deepanalysis' && <DeepanalysisTab />}
              {activeTab === 'subscription' && <SubscriptionTab />}
              {activeTab === 'clientsetup' && <ClientSetupTab />}
              {activeTab === 'clientscorecard' && <ClientScorecardTab />}
              {activeTab === 'configuration' && <ConfigurationTab />}
              {activeTab === 'support' && <ContactUsTab />}
              {activeTab === 'help' && <HelpTab />}
              {activeTab === 'copilot' && <CoPilotTab />}
              {activeTab === 'reports' && <ReportsTab />}
              {activeTab === 'home' && <LandingPage onSelectTab={setActiveTab} />}
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md">
              <Authenticator components={components} hideSignUp />
            </div>
          </div>
        )
      }
    </Authenticator>
  );
};

export default App;

